import { format } from 'date-fns'
import { startOfWorkDay } from '@/lib/shiftTime'

export const pageConfig: PageConfig = {
  urlRegExp: /^\/locations\/(\w+)$/m,
  visitOptionsHook(href, options) {
    if (options.data instanceof FormData) {
      return options
    }

    const url = new URL(href, window.location.origin)
    const data = {
      ...Object.fromEntries(url.searchParams.entries()),
      ...(options.data as any),
    }

    return {
      ...options,
      data: {
        ...(() => {
          if (data?.from && data?.to) {
            return {}
          }

          const now = format(startOfWorkDay(new Date()), 'yyyy-MM-dd')
          return { from: now, to: now }
        })(),
        shift: data?.shift || 'A',
        ...options.data,
      },
    }
  },
}
